<template>
  <layout name="LayoutDefault">
    <div class="About">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row ">
            <div class="col-lg-12 ">
              <div class="col-lg-2 ml-auto p-0">
                <select class="form-control category-order">
                  <option :value="
                    `${baseUrl}category/${this.$route.params.categoryId
                    }/newest`
                  ">Newest First</option>
                  <option :value="
                    `${baseUrl}category/${this.$route.params.categoryId
                    }/oldest`
                  ">Oldest First</option>
                  <option :value="
                    `${baseUrl}category/${this.$route.params.categoryId}/az`
                  ">A-Z</option>
                  <option :value="
                    `${baseUrl}category/${this.$route.params.categoryId}/za`
                  ">Z-A</option>
                </select>
              </div>

              <div class="section-items ">
                <pagination v-bind="pagination">
                  <div slot-scope="{ scope }">
                    <div class="row">
                      <div v-for="(item, k) in scope" :key="k" class="col-lg-2 col-sm-6 col-6 mb-2 section-item books">
                        <a :href="`${baseUrl}book/${item.id}`">

                          <!-- <div v-if="item.discount > 0" class="discount-badge">
                            <span>{{ item.discount }}</span>
                            <span v-if="item.discount_type == 'Percent'">%</span>
                            <span v-else class="taka-off">Tk.</span>
                            <div>OFF</div>
                          </div> -->

                          <vue-load-image>
                            <img slot="image" v-bind:src="`${IMAGEURL}${item.image}`" alt="" class="img-responsive" />
                            <img slot="preloader" v-bind:src="`${IMAGEURL}/assets/img/loader.gif`" title="Loading Image..." />
                            <div slot="error">can't load image</div>
                          </vue-load-image>
                          <h4 v-if="item.product_name.length < 14">
                            {{ item.product_name }}
                          </h4>
                          <h4 v-if="item.product_name.length >= 14" :title="`${item.product_name}`">
                            {{ item.product_name.substr(0, 14) + "..." }}
                          </h4>
                        </a>
                        <span v-for="(author, index) in item.authors" v-bind:key="index">
                          <a :href="`${baseUrl}author/${author.author_id}`">{{
                              author.author_name
                          }}</a>
                          <span v-if="index + 1 < item.authors.length">, </span>
                        </span>
                        <div class="item-price">
                          <div v-if="item.discount > 0" class="item-price">Price: Tk. {{ item.price }}
                          </div>
                          <div class="item-regular-price">Regular Price: Tk. {{ item.orginal_price }} </div>
                        </div>
                        <div class="hover-item">
                          <div class="arrow-up"></div>
                          <a href="javascript:;" @click="addToCart(item)" class="btn btn-primary add-to-cart">Add to Cart</a>
                          <a :href="`${baseUrl}book/${item.id}`" class="btn btn-black view-details">View Details</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </pagination>

                <div v-if="pagination.items.length < 1 && !loading">
                  কোন বই পাওয়া যায়নি
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import VueLoadImage from "vue-load-image";
import Pagination from "vue-and-pagination";

export default {
  data() {
    return {
      categoryName: "Loading...",
      loading: true,
      pagination: {
        items: [],
        limit: 12,
        controlsOnTop: false,
        controlsOnBottom: true,
        page: 1,
        sidePagesNumber: 2
      }
    };
  },
  components: {
    Layout,
    "vue-load-image": VueLoadImage,
    Pagination
  },
  methods: {
    getProducts() {
      fetch(
        this.APIURL +
        "products-resources/category/" +
        this.$route.params.categoryId +
        "/" +
        this.$route.params.order
      )
        .then(response => response.json())
        .then(json => {
          this.pagination.items = json.data;
          if (this.pagination.items.length > 0) {
            this.categoryName = json.data[0].category_name;
          }
          this.loading = false;
        });
    },
    addToCart(row) {
      let itemObj = {
        session_id: localStorage.getItem("session_id"),
        product_id: row.id,
        image: row.image,
        price: row.price,
        quantity: 1,
        name: row.product_name
      };
      this.$helper.saveToCart(itemObj);
      var cartCount = this.$helper.cartCount();
      $(".cart-count").text(cartCount);
      this.flashMessage.success({ message: "Added item to cart" });
    },
  },
  mounted() {
    this.getProducts();
  }
};
</script>
